import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_MESSAGE,
} from "./types";

import AuthService from "../services/auth.service";

export const login = (email, password, rememberMe) => (dispatch) => {
  console.log(email,password,"email and pas");
  
  return AuthService.login(email, password, rememberMe).then(
    (data) => {
      if (data.userInfo) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data.userInfo },
        });
      }

      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const verifyLogin = (email, code, rememberMe) => (dispatch) => {
  return AuthService.verifyLoginCode(email, code, rememberMe).then(
    (data) => {
      if (data.userInfo) {
        dispatch({
          type: LOGIN_SUCCESS,
          payload: { user: data.userInfo },
        });
      }
      return Promise.resolve(data);
    },
    (error) => {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      dispatch({
        type: LOGIN_FAIL,
      });

      dispatch({
        type: SET_MESSAGE,
        payload: message,
      });

      return Promise.reject();
    }
  );
};

export const logout = () => (dispatch) => {
  AuthService.logout();

  dispatch({
    type: LOGOUT,
  });
};
